import React from 'react';
import { Skeleton as MUISkeleton } from '@mui/material';

const Skeleton = (props) => {
  const sxOverride = { ...props?.sx, background: '#193247' };
  return <MUISkeleton {...props} sx={sxOverride} />;
};

export default Skeleton;
